export const unMaskCurrency = (valor?: string): number => {
  if (valor) {
    if (typeof valor === 'number') {
      valor = String(valor)
    }

    const isNegative = valor.trim().startsWith('-') || valor.trim().endsWith('-')

    const numeric = valor
      .replace(/[^\d.,]/g, '')
      .replace(',', '.')
      .replace(/\.(?=.*\.)/g, '')
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1')

    const parsed = parseFloat(numeric)

    return isNaN(parsed) ? 0 : isNegative ? -parsed : parsed
  }

  return 0
}
